import { getAdminUiUrlByPlatform } from 'utils/adminUi'
import { getEnvPath, findOutWhichEnv } from '../../utils/env'
import { getHeaders, handleErrors } from './utils'
import { getPlatform, getToken } from '../../utils/token/token'

const env = findOutWhichEnv()
const BASE_PATH = `${getEnvPath(env)}/1.0/api`

function get(payload) {
  return fetch(`${BASE_PATH}/hsm/scheduled-dispatch-filter`, getHeaders('POST', { ...payload }))
    .then((r) => r.json())
    .then(handleErrors)
}

function getModels() {
  return fetch(`${BASE_PATH}/hsm/phone`, getHeaders('GET'))
    .then((r) => r.json())
    .then(handleErrors)
}

function create(payload) {
  return fetch(`${BASE_PATH}/hsm/scheduled-dispatch/dispatch`, getHeaders('POST', { ...payload })).then((r) => r)
}

function send(payload) {
  return fetch(`${BASE_PATH}/hsm/external_template_dispatch`, getHeaders('POST', { ...payload })).then((r) => r)
}

function uploadFile(formData, templateId) {
  const options = {
    method: 'POST',
    body: formData,
    headers: new Headers({ Authorization: `DT-Fenix-Token ${getToken()}` }),
  }
  return fetch(`${BASE_PATH}/hsm/scheduled-dispatch/upload-spreadsheet?templateId=${templateId}`, options)
    .then((r) => r.json())
    .then(handleErrors)
}

function uploadHeaderFile(formData) {
  const options = {
    method: 'POST',
    body: formData,
    headers: new Headers({ Authorization: `DT-Fenix-Token ${getToken()}` }),
  }
  return fetch(`${BASE_PATH}/hsm/media/upload`, options)
    .then((r) => r.json())
    .then(handleErrors)
}

function getDepartmentList() {
  const plat = getPlatform()
  return fetch(`${getAdminUiUrlByPlatform(plat)}/api/WhatsApp/departments`, getHeaders('GET')).then((r) => r.json())
}

export { create, get, getModels, uploadFile, uploadHeaderFile, send, getDepartmentList }
